import Vue from 'vue'

export default function (component, propsData, container) {
  const customProps = { ...propsData };

  const ComponentClass = Vue.extend(Vue.component("custom-component", component));
  const instance = new ComponentClass({
    propsData: customProps
  });
  instance.$mount(`#${container}`);
}
